export function TypographyColors() {
  return (
    <div className="flex flex-col gap-8 text-left">
      <h1 className="font-bold leading-snug tracking-tight text-slate-800 mx-auto w-full text-2xl lg:max-w-3xl lg:text-5xl">
        Material Tailwind
      </h1>
      <h1 className="font-bold leading-snug tracking-tight text-blue-600 mx-auto w-full text-2xl lg:max-w-3xl lg:text-5xl">
        Material Tailwind
      </h1>
      <h1 className="font-bold leading-snug tracking-tight text-red-600 mx-auto w-full text-2xl lg:max-w-3xl lg:text-5xl">
        Material Tailwind
      </h1>
      <h1 className="font-bold leading-snug tracking-tight text-green-600 mx-auto  w-full text-2xl lg:max-w-3xl lg:text-5xl">
        Material Tailwind
      </h1>
    </div>
  );
}
